function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.825.158L5 3.975 1.175.158 0 1.333l5 5 5-5z"
});
const SvgIcExpandMore = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 7,
  viewBox: "0 0 10 7",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcExpandMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-expand-more.fedfc181.svg";
export { ForwardRef as ReactComponent };